<template>
  <div>
    <!-- 中药小包装、中草药、颗粒 - 用药信息 -->
    <uni-popup ref="drug" type="bottom" @change="onPopupChange">
      <uni-card title="用药信息" :is-full="true" :note="true">
        <div
          v-if="
            ['4', '5', '6'].includes(drugMsg.drugType) || ['3', '5', '6'].includes(prescripType)
          "
          class="drug_wrap"
        >
          <scroll-view
            :upper-threshold="-50"
            :scroll-top="0"
            :scroll-y="true"
            :scroll-anchoring="true"
            style="height: 18.346667rem"
          >
            <div class="drug_msg">
              <div class="row_wrap">
                <span class="drug_name">
                  {{ drugMsg.commonName || drugMsg.drugName }}
                </span>
                <span class="price"> ¥ {{ drugMsg.price || drugMsg.drugPrice }} </span>
              </div>
              <div class="row_wrap">
                <span class="specification"> {{ drugMsg.drugSpec }} {{ getUnit() }} </span>
              </div>
              <div class="row_wrap">
                <span class="manufacturer">{{ drugMsg.manufacturer }}</span>
                <div class="check-leaflet" @click="handleCheckLeaflet(drugMsg)">查看说明书</div>
              </div>
              <div class="row_wrap">
                <span class="stockQuantity">
                  库存剩余：{{ drugMsg.stockQuantity || stockQuantity }}
                </span>
              </div>
            </div>
            <div class="">
              <div class="input_wrap useAuantity use_style">
                <span class="input_title">单次剂量：</span>
                <div class="input_row">
                  <input
                    v-model="form.useAuantity"
                    type="digit"
                    placeholder="请输入"
                    placeholder-style="color:#CECECE;font-size:.597333rem"
                    placeholder-class="input-placeholder"
                    class="input_con"
                    @input="updateUseAuantity"
                  />
                  <span class="unit">
                    <!-- {{ getKeyValueText('measure_unit', drugMsg.measureUnit) }} -->
                    {{
                      drugMsg.measureUnit || getKeyValueText('measure_unit', drugMsg.measureUnit)
                    }}
                  </span>
                </div>
              </div>
            </div>
            <ms-select-dicNew
              :code="'prescrip_desc'"
              :title="'说明：'"
              :rightText="drugDesc"
              :uniListTop="true"
              @changeDicValue="changeDrugDesc"
            ></ms-select-dicNew>
          </scroll-view>
        </div>
        <div v-else class="drug_wrap">
          <scroll-view
            :upper-threshold="-50"
            :scroll-top="0"
            :scroll-y="true"
            :scroll-anchoring="true"
            style="height: 18.346667rem"
            @scrolltolower="getMoreList"
          >
            <div class="drug_msg">
              <div class="row_wrap">
                <!-- 蒙药 （蒙） -->
                <span
                  :class="[
                    { mdrug: drugMsg.drugType === '3' || prescripType === '4' },
                    'drug_name'
                  ]"
                >
                  {{ drugMsg.commonName || drugMsg.drugName }}
                </span>
                <span class="price"> ¥ {{ drugMsg.price || drugMsg.drugPrice }} </span>
              </div>

              <div class="row_wrap">
                <span
                  :class="[
                    { mdrug: drugMsg.drugType === '3' || prescripType === '4' },
                    'specification'
                  ]"
                >
                  {{ drugMsg.drugSpec }}
                </span>
                <div class="check-leaflet" @click="handleCheckLeaflet(drugMsg)">查看说明书</div>
              </div>
              <div class="row_wrap">
                <span class="stockQuantity">
                  库存剩余：{{ drugMsg.stockQuantity || stockQuantity }}
                </span>
              </div>
            </div>
            <uni-list-item
              v-if="isMeng"
              title="药品用法："
              :show-arrow="true"
              :clickable="true"
              :right-text="getKeyValueText('drug_usage_meng_his', form.drugUsage) || '请选择'"
              @click="clickDrugUsage"
            />

            <ms-select-dicNew
              v-if="!isMeng"
              code="drug_usage_his"
              title="药品用法："
              :uniListTop="true"
              :rightText="form.drugUsage"
              @changeDicValue="changeDrugUsage"
            ></ms-select-dicNew>

            <uni-list-item
              v-if="isMeng"
              title="用药时间："
              :show-arrow="true"
              :clickable="true"
              :right-text="getKeyValueText('drug_use_time', form.useDrugTime) || '请选择'"
              @click="clickUseDrugTime"
            />

            <ms-select-dicNew
              v-if="!isMeng"
              :code="'frequence_his'"
              :title="'用药次数：'"
              :rightText="form.frequence"
              :uniListCellTop="true"
              @changeDicValue="changeFrequence"
            ></ms-select-dicNew>

            <uni-list-item
              v-if="isMeng"
              title="是否药引："
              :show-arrow="false"
              :clickable="true"
              :show-switch="true"
              switch-type="checkbox"
              :switch-checked="!!Number(form.isDrugInducer)"
              @switchChange="switchChange"
            />
            <div class="uni-textarea">
              <div class="input_wrap useAuantity">
                <span class="input_title">单次剂量：</span>
                <div v-if="isMeng" class="input_row">
                  <input
                    v-model="form.useAuantity"
                    :always-embed="true"
                    class="input_con"
                    type="digit"
                    placeholder="请输入"
                    placeholder-style="color:#CECECE;font-size:.597333rem"
                    placeholder-class="input-placeholder"
                  />
                  <span class="unit">
                    <!-- {{
                      getKeyValueText('measure_unit_meng', drugMsg.measureUnit)
                    }} -->
                    {{
                      drugMsg.measureUnit ||
                      getKeyValueText('measure_unit_meng', drugMsg.measureUnit)
                    }}
                  </span>
                </div>
                <div v-else class="input_row">
                  <input
                    v-model="form.useAuantity"
                    :always-embed="true"
                    class="input_con"
                    type="digit"
                    placeholder="请输入"
                    placeholder-style="color:#CECECE;font-size:.597333rem"
                    placeholder-class="input-placeholder"
                    @input="clickInput"
                  />
                  <span class="unit">
                    {{ getKeyValueText('measure_unit', drugMsg.measureUnit) }}
                  </span>
                </div>
              </div>
            </div>
            <div class="uni-textarea">
              <div class="input_wrap">
                <span class="input_title">用药天数：</span>
                <div class="input_row">
                  <div>
                    <input
                      v-model="form.useDays"
                      :always-embed="true"
                      type="number"
                      class="input_con"
                      placeholder="请输入"
                      placeholder-style="color:#CECECE;font-size:.597333rem"
                      placeholder-class="input-placeholder"
                      @input="clickInput"
                    />
                  </div>
                  <span
                    :class="[
                      {
                        mdrug: drugMsg.drugType === '3' || prescripType === '4'
                      },
                      'unit'
                    ]"
                  >
                    {{ isMeng ? '' : '天' }}
                  </span>
                </div>
              </div>
            </div>
            <div class="uni-textarea">
              <div class="input_wrap">
                <span class="input_title">发药数量：</span>
                <div class="input_row">
                  <input
                    v-model="form.amount"
                    :disabled="enableEditAmount"
                    :always-embed="true"
                    class="input_con"
                    type="number"
                    placeholder="请输入"
                    placeholder-style="color:#CECECE;font-size:.597333rem"
                    placeholder-class="input-placeholder"
                  />
                  <span
                    :class="[
                      {
                        mdrug: drugMsg.drugType === '3' || prescripType === '4'
                      },
                      'unit'
                    ]"
                  >
                    {{ drugMsg.packageUnit }}
                  </span>
                </div>
              </div>
            </div>
            <div class="uni-textarea tip">
              <span class="input_title">嘱托：</span>
              <textarea
                v-model="form.attention"
                placeholder="请输入嘱托"
                placeholder-style="color:#cecece;font-size:.64rem"
                placeholder-class="textarea-placeholder"
                :show-confirm-bar="false"
              ></textarea>
            </div>
            <!-- </uni-card> -->
          </scroll-view>
        </div>
        <template v-slot:footer>
          <div class="footer-box">
            <span class="btn" @click="confirmAddDrug">完成</span>
            <span class="btn" @click="confirmAddDrug(1)">继续添加</span>
          </div>
        </template>
        <template v-slot:close>
          <uni-icons type="closeempty" color="#666" @click="close" />
        </template>
      </uni-card>
    </uni-popup>
    <ms-drug-leaflet ref="drugLeafletModal" />
    <uni-popup ref="prescripTipPop">
      <div class="popup-wrap">
        <div class="content-wrap">
          <span class="theSon">{{ codeDesc }}</span>
        </div>
        <div class="have-know" @click="haveKnow">
          <span>我知道了</span>
        </div>
      </div>
    </uni-popup>
    <uni-popup ref="useDialog" type="dialog">
      <uni-popup-dialog
        :showTitle="false"
        mode="base"
        :content="tip"
        :stockLack="true"
        :confirmText="'知道了'"
        :showConfirmButton="true"
        :showCancelButton="false"
        @confirm="confirmDialog"
      />
    </uni-popup>

    <ms-select-dicValue
      ref="dicPopup"
      :code="isMeng ? 'drug_usage_meng_his' : 'drug_usage_his'"
      :value="form.drugUsage"
      v-model:visible="showDicPopup"
      @change="setDrugUsage"
      @start="startDrugUsage"
    ></ms-select-dicValue>

    <ms-select-dicValue
      ref="useDrugTimePopup"
      :code="'drug_use_time'"
      :value="form.useDrugTime"
      v-model:visible="showUseDrugTimePopup"
      @change="setUseDrugTime"
      @start="startUseDrugTime"
    ></ms-select-dicValue>

    <uni-popup ref="limitDialog" type="dialog">
      <uni-popup-dialog
        mode="base"
        :showTitle="true"
        :title="'药品限制性用药说明'"
        :content="limitText"
        :stockLack="true"
        :confirmText="'是'"
        :showConfirmButton="true"
        :cancelText="'否'"
        :showCancelButton="true"
        @confirm="confirmEvent"
        @close="cancelEvent"
      />
    </uni-popup>
  </div>
</template>

<script>
import { getKeyValue, getKeyValueText } from '@/views/funcPuzzle/utils/util.js'
import { getBusinessValueByCode, getBusinessConfig } from '@/views/funcPuzzle/utils/index.js'
import { mapState } from 'vuex'
import { aCheckDrugStock } from '@/views/funcPuzzle/utils/index.js'
import MsSelectDicValue from '@/views/funcPuzzle/components/ms-select-dicValue/ms-select-dicValue.vue'
import MsSelectDicNew from '@/views/funcPuzzle/components/ms-select-dicNew/ms-select-dicNew.vue'
import MsDrugLeaflet from '@/views/funcPuzzle/components/ms-drug-leaflet/ms-drug-leaflet.vue'
import { syncDebounce } from '@/utils/debounce'

export default {
  components: {
    'ms-select-dicValue': MsSelectDicValue,
    MsDrugLeaflet,
    'ms-select-dicNew': MsSelectDicNew
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    drugMsg: {
      type: [Object, String],
      default: ''
    },
    warehouseID: {
      type: [String],
      default: ''
    },
    ifUpdate: {
      type: Boolean,
      default: false
    },
    ifCopy: {
      type: Boolean,
      default: false
    },
    prescripType: {
      type: [Object, String],
      default: ''
    }
  },
  data() {
    return {
      enableEditAmount: true,
      showDicPopup: false,
      showUseDrugTimePopup: false,
      array: [
        { value: '选项1', code: 1 },
        { value: '选项2', code: 2 },
        { value: '选项3', code: 3 },
        { value: '选项4', code: 4 }
      ],
      smallPhysicSpec: '',
      drugList: [],
      drugDesc: '',
      form: {
        hospitalID: '',
        visitID: '',
        drugID: '',
        refDrugID: '',
        drugName: '',
        drugSpec: '',
        drugPrice: '',
        drugUsage: '',
        frequence: '',
        mindoseUnit: '',
        useAuantity: '',
        useDays: '',
        amount: '',
        attention: '',
        useDrugTime: '',
        isDrugInducer: '0',
        drugFlag: ''
      },
      isMeng: false,
      prescripClass: '',
      doesNumber: '',
      limitConfig: null,
      codeDesc: '',
      stockQuantity: '',
      tip: ''
    }
  },
  methods: {
    getKeyValueText,
    onPopupChange({ show }) {
      if (!show) {
        this.$emit('update:visible', false)
      }
    },
    getMoreList() {
      // 修复js报错，暂时找不到getMoreList方法内容
    },
    // 发药数量能否编辑 业务字典
    async getEditDispensedMedicineAmount() {
      const key = 'edit_dispensed_medicine_amount'
      try {
        const res = await getBusinessConfig(key, this.hospitalID)
        if (
          res.code === 0 &&
          res.DoctorServicePackageList &&
          res.DoctorServicePackageList.length > 0
        ) {
          // 发药数量能否编辑: 1 ： 能，-1: 不能
          this.enableEditAmount = res.DoctorServicePackageList[0].value === '1' ? false : true
        } else {
          // 发药数量配置没有添加 能够正常编辑
          this.enableEditAmount = false
        }
      } catch (error) {
        console.log(error)
      }
    },
    clickDrugUsage() {
      this.$refs.dicPopup.open()
      this.showDicPopup = true
    },
    clickUseDrugTime() {
      this.$refs.useDrugTimePopup.open()
      this.showUseDrugTimePopup = true
    },
    // 药品用法
    changeDrugUsage(val) {
      this.form.drugUsage = val
    },
    changeFrequence(val) {
      this.form.frequence = val
      this.clickInput()
    },
    changeDrugDesc(val) {
      this.drugDesc = val
    },
    confirmEvent() {
      // 同意则调用群发消息接口
      this.form.phaSpecialLimit = '1'
    },
    cancelEvent() {
      this.form.phaSpecialLimit = '0'
    },
    showExplain() {
      this.$refs.limitDialog.open()
    },
    getUnit() {
      return this.drugMsg.smallPhysicSpec
        ? '(' +
            this.drugMsg.smallPhysicSpec
              .split(';')
              .map(val => {
                return val + 'g'
              })
              .join('/') +
            ')'
        : ''
    },

    startDrugUsage(val) {
      this.form.drugUsage = val
    },
    setDrugUsage(val) {
      this.form.drugUsage = val
    },

    startUseDrugTime(val) {
      this.form.useDrugTime = val
    },
    setUseDrugTime(val) {
      this.form.useDrugTime = val
    },
    close() {
      if (!this.$refs.drug) {
        return false
      }
      // this.$emit('update:visible', false)

      this.$refs.drug.close()

      this.$bus.emit('cancelAddDrug', true)
    },
    async clickInput(e) {
      this.checkDays()
      this.form.frequence = this.isMeng ? '1' : this.form.frequence //逻辑不明，暂未注释
      const frequence = this.isMeng
        ? 1
        : await getBusinessValueByCode('frequence_count_his', this.form.frequence)

      // 宁城中心医院单独判断 28770
      let amount
      if (['28770'].includes(this.hospitalID) && this.drugMsg.doseCoeff) {
        amount = Math.ceil(
          (this.form.useDays * frequence * this.form.useAuantity) / this.drugMsg.doseCoeff
        )
      } else {
        amount = Math.ceil(
          (this.form.useDays * frequence * this.form.useAuantity) /
            (this.drugMsg.mindoseUnit * this.drugMsg.packageNumber)
        )
      }

      this.form.amount = amount ? amount : ''
    },
    // 修改单次剂量
    updateUseAuantity(e) {
      // this.clickInput()
    },
    checkDays() {
      // 如果有配置
      if (this.limitConfig) {
        // 如果天数超过配置
        if (this.form.useDays > this.limitConfig.days) {
          uni.showToast({
            title: `用药天数超过${this.limitConfig.days}天`,
            icon: 'none'
          })
        }
        return false
      }
    },
    checkDrugStock(drugID, drugName, drugType, count, type) {
      const params = {
        drugs: [
          {
            drugId: drugID,
            drugName,
            drugType,
            amount: count,
            warehouseID: this.warehouseID
          }
        ],
        flag: '1'
      }
      aCheckDrugStock(params).then(rs => {
        if (rs.DrugList && rs.DrugList[0]) {
          // 互联网药房不校验库存 只有院内药房校验库存
          if (parseInt(rs.DrugList[0].stockQuantity) < count && this.warehouseID !== '1002') {
            // 院内药房的药品库存不足
            uni.showToast({
              title: '药品库存不足',
              icon: 'none'
            })
          } else {
            const base =
              (rs.DrugList[0].dailyConsumption || rs.DrugList[0].dailyConsumption == 0) &&
              rs.DrugList[0].dailyConsumption - Number(rs.DrugList[0].useConsumption) < count
            // 中草药类型 需要this.form.doesNumber 有的情况下 才判断

            const condition = ['4', '5', '6'].includes(this.drugMsg.drugType)
              ? base && this.doesNumber
              : base
            // 校验药品发药数量是否超过可开具数量 此时库存是充足的
            // 校验药品发药数量超过了可开具数量
            if (condition) {
              // 调起弹窗
              this.issuableModal(rs, count)
            } else {
              const drugCount = this.calculateAmount(this.form, this.drugMsg)

              const drugDesc = {
                drugDesc: this.drugDesc
              }
              this.form = Object.assign(this.drugMsg, this.form, drugDesc, drugCount)

              this.form.drugName = this.drugMsg.commonName || this.drugMsg.drugName
              this.form.drugPrice = this.drugMsg.price || this.drugMsg.drugPrice

              this.$bus.emit('drugItem', {
                val: this.form,
                val2: this.ifUpdate
              })
              this.$refs.drug.close()
              // this.$emit('update:visible', false)
              // 继续显示添加药品
              if (type == 1) {
                this.$emit('showAddDrug')
              }
            }
          }
        }
        // 库存校验报错的提示
        else if ([-1, -2].includes(rs.code) && !rs.DrugList) {
          this.codeDesc = rs.codeDesc || rs.msg
          // 失败弹窗提示
          this.prescripTipOpen()
          return false
        }
      })
    },
    // 单纯只查询库存 没有校验
    pureGetStock() {
      const params = {
        drugs: [
          {
            drugId: this.drugMsg.drugID,
            drugName: this.drugMsg.drugName,
            drugType: this.drugMsg.drugType,
            amount: this.drugMsg.amount,
            warehouseID: this.warehouseID
          }
        ],
        flag: '1'
      }
      aCheckDrugStock(params).then(rs => {
        this.stockQuantity = rs.DrugList[0].stockQuantity
      })
    },
    switchFunc() {
      // 中成药、西药、蒙药 用的是packageUnit
      const chinesePatentVals = ['1', '2', '8']
      // 中草药、小包装、中药颗粒 用的是measureUnit
      const chineseHerbalVals = ['4', '5', '6']
      switch (this.drugMsg.drugType) {
        case chinesePatentVals[0]:
        case chinesePatentVals[1]:
        case chinesePatentVals[2]:
          return getKeyValueText('package_unit', this.drugMsg.packageUnit)
        // 蒙药（蒙）用的是packageUnit
        case '3':
          return getKeyValueText('package_unit_meng', this.drugMsg.packageUnit)
        case chineseHerbalVals[0]:
        case chineseHerbalVals[1]:
        case chineseHerbalVals[2]:
          return getKeyValueText('measure_unit', this.drugMsg.measureUnit)
      }
    },
    // 校验药品发药数量是否超过可开具数量 弹窗
    issuableModal(rs, count) {
      const unit = this.switchFunc(this.drugMsg.drugType)

      this.tip = `${this.drugMsg.commonName || this.drugMsg.drugName} 单日消耗总量限制为 【${
        rs.DrugList[0].dailyConsumption
      }】${unit}，当前可开具【${
        rs.DrugList[0].dailyConsumption > rs.DrugList[0].useConsumption
          ? rs.DrugList[0].dailyConsumption - rs.DrugList[0].useConsumption
          : 0
      }】${unit}，您开具的【${count}】${unit}已超量。`

      this.$refs.useDialog.open()

      return false
    },
    haveKnow() {
      this.$refs.prescripTipPop.close()
    },
    prescripTipOpen() {
      this.$refs.prescripTipPop.open()
    },
    switchChange(e) {
      this.form.isDrugInducer = e.value ? '1' : '0'
    },
    // type == 1 表示要继续添加药品
    async confirmAddDrug(type) {
      // this.$refs.drugDesc.close()
      if (!this.form.useAuantity || this.form.useAuantity === '0') {
        uni.showToast({
          title: '请填写单次剂量',
          icon: 'none'
        })
        return false
      }
      if (
        ['1', '2', '3', '8'].includes(this.drugMsg.drugType) ||
        ['1', '2', '4', '8'].includes(this.prescripType)
      ) {
        if (!this.form.drugUsage) {
          uni.showToast({
            title: '请填写药品用法',
            icon: 'none'
          })
          return false
        }
        if (!this.form.frequence) {
          uni.showToast({
            title: '请填写用药次数',
            icon: 'none'
          })
          return false
        }
        if (this.isMeng && !this.form.useDrugTime) {
          uni.showToast({
            title: '请填写用药时间',
            icon: 'none'
          })
          return false
        }

        if (!this.form.useDays) {
          uni.showToast({
            title: '请填写用药天数',
            icon: 'none'
          })
          return false
        }

        // 如果有配置
        if (this.limitConfig) {
          // 如果天数超过配置
          if (this.form.useDays > this.limitConfig.days) {
            uni.showToast({
              title: `用药天数超过${this.limitConfig.days}天`,
              icon: 'none'
            })
            // 判断配置项是否允许提交，配置项开启不可提交
            if (this.limitConfig.isLimit === 1) {
              return false
            }
          }
        }

        if (!this.form.amount || this.form.amount === '0') {
          uni.showToast({
            title: '请填写发药数量',
            icon: 'none'
          })
          return false
        }
      }

      this.isDivisible = false
      let res = ''
      if (this.drugMsg.smallPhysicSpec) {
        res = this.drugMsg.smallPhysicSpec.split(';').find(value => {
          return this.form.useAuantity % value === 0
        })
      }

      if (!res && this.drugMsg.smallPhysicSpec) {
        const smallPhysicSpec = this.drugMsg.smallPhysicSpec.split(';').map(item => {
          return '【' + item + '】'
        })

        const title =
          '药品' +
          '【' +
          (this.drugMsg.commonName || this.drugMsg.drugName) +
          '】' +
          '有以下开药规格，' +
          smallPhysicSpec +
          '，当前开的单次剂量' +
          '【' +
          this.form.useAuantity +
          '】' +
          '不能按整数发药；'

        uni.showModal({
          content: title,
          showCancel: false,
          buttonText: '确定',
          success: res => {
            if (res.confirm) {
              return false
            }
          }
        })
        return false
      }

      const amount = ['4', '5', '6'].includes(this.drugMsg.drugType)
        ? this.calculateAmount(this.form, this.drugMsg)
        : this.form.amount
      // 添加防抖修复点击多次添加多个重复药品
      await syncDebounce()
      this.checkDrugStock(
        this.drugMsg.drugID,
        this.drugMsg.drugName || this.drugMsg.commonName,
        this.drugMsg.drugType,
        amount,
        type
      )
    },
    confirmDialog() {
      this.form.amount = ''
      if (['4', '5', '6'].includes(this.drugMsg.drugType)) {
        this.form.useAuantity = ''
      }
      this.$refs.useDialog.close()
      return false
    },
    calculateAmount(val1, val2) {
      // 计算药品数量
      let count = ''

      if (
        (['4', '5', '6'].includes(val2.drugType) || ['3', '5', '6'].includes(this.prescripType)) &&
        this.doesNumber
      ) {
        // 20230414迭代 产品说 不/packageNumber了
        count = Math.ceil(
          this.doesNumber * val1.useAuantity
          // / Number(val2.packageNumber)
        )
      }

      return count
    },
    open() {
      // this.setDrugDesc('1')
      // this.$emit('update:visible', true)
      this.$refs.drug.open()
    },
    // 获取用药天数限制的配置
    async fetchDrugDaysConfig() {
      try {
        const config = localStorage.getItem('UseDrugDaysConfig')
        if (config) {
          this.limitConfig = JSON.parse(config)
        }
      } catch (error) {
        console.log(error)
      }
    },
    //  点击查看药品说明书按钮
    async handleCheckLeaflet(drug) {
      this.$store.dispatch('setLeafletStatus', true)
      this.$store.dispatch('setLeafletData', drug)
    }
  },
  watch: {
    visible(val) {
      // 获取用药天数限制的配置，第一次获取可能缓存没有
      this.fetchDrugDaysConfig()
      const updateFormData = () => {
        const drugUsage = getKeyValue('drug_usage_his')[0].code
        const frequence = getKeyValue('frequence_his')[0].code

        const val = this.drugMsg
        if (val.drugType === '3' || this.prescripType === '4') {
          this.isMeng = true
        }

        // 根据需求调整 2023/10/26 17:00
        // 判断药品数据中的用法是否有效，如果有效则使用药品数据中的用法，否则使用默认用法
        this.form.drugUsage = getKeyValueText('drug_usage_his', val.drugUsage)
          ? val.drugUsage
          : drugUsage
        if (['1', '2', '8'].includes(val.drugType) || ['1', '2', '8'].includes(this.prescripType)) {
          this.form.useDays = this.drugMsg.useDays
          this.form.amount = this.drugMsg.amount
          // 只有中成药、西药、以及呼市蒙药 需要回显单次剂量 其他类型不需要
          this.form.useAuantity = val.useAuantity || val.mindoseUnit
        }

        this.form.drugID = val.drugID
        // 原来的逻辑是如果有默认频次就用默认频次，没有就用频次，
        // 现在改成如果有默认频次就用默认频次，没有就用频次，都没有就用默认频次
        // this.form.frequence = val.defaultFrequence || val.frequence || frequence
        // 2021/10/26 17:00
        // 判断药品数据中的用药次数是否有效，如果有效则使用药品数据中的用药次数，否则使用默认用药次数
        this.form.frequence =
          getKeyValueText('frequence_his', val.defaultFrequence) ||
          val.defaultFrequence ||
          val.frequence ||
          frequence

        this.form.drugName = val.commonName || val.drugName
        this.form.drugPrice = val.price || val.drugPrice
        this.form.drugSpec = val.drugSpec
        this.form.hospitalID = val.hospitalID
        this.form.refDrugID = val.id
        this.form.permitNO = val.permitNO
        this.form.drugFlag = val.drugFlag
        this.form.mindoseUnit = val.mindoseUnit
      }
      if (val) {
        if (this.drugMsg.phaSpecialLimitContent && this.hospitalID === '26281') {
          // 展示药品使用限制的弹窗提示
          this.showExplain()
        }

        // this.getEditDispensedMedicineAmount()

        this.$bus.on('doesNumber', val => {
          this.doesNumber = val
        })
        this.$refs.drug.open()
        // 处于修改或者复制状态
        if (this.ifUpdate || this.ifCopy) {
          // 请求查询库存接口
          this.pureGetStock()
        }
        if (!this.ifUpdate) {
          this.drugDesc = ''
          const drugUsage = getKeyValue('drug_usage_his')[0].code
          const frequence = getKeyValue('frequence_his')[0].code
          this.form = {
            hospitalID: '',
            visitID: '',
            drugID: '',
            refDrugID: '',
            drugName: '',
            drugSpec: '',
            drugPrice: '',
            drugUsage,
            frequence: this.drugMsg.defaultFrequence ? frequence : this.drugMsg.defaultFrequence,
            mindoseUnit: '',
            useAuantity: '',
            useDays: '',
            amount: '',
            attention: '',
            useDrugTime: '',
            isDrugInducer: '0',
            drugFlag: new Date().getTime()
          }
        } else {
          if (
            ['1', '2', '8'].includes(this.drugMsg.drugType) ||
            ['1', '2', '8'].includes(this.prescripType)
          ) {
            this.form = {
              hospitalID: '',
              visitID: '',
              drugID: '',
              refDrugID: '',
              drugName: '',
              drugSpec: '',
              drugPrice: '',
              drugUsage: '',
              frequence: this.drugMsg.defaultFrequence,
              mindoseUnit: '',
              useAuantity: this.drugMsg.useAuantity,
              useDays: this.drugMsg.useDays,
              amount: this.drugMsg.amount,
              attention: this.drugMsg.attention,
              useDrugTime: '',
              isDrugInducer: '0',
              drugFlag: new Date().getTime()
            }
          } else if (
            ['4', '5', '6'].includes(this.drugMsg.drugType) ||
            ['3', '5', '6'].includes(this.prescripType)
          ) {
            this.drugDesc = this.drugMsg.drugDesc
            this.form = {
              hospitalID: '',
              visitID: '',
              drugID: '',
              refDrugID: '',
              drugName: '',
              drugSpec: '',
              drugPrice: '',
              drugUsage: '',
              frequence: this.drugMsg.defaultFrequence,
              mindoseUnit: '',
              useAuantity: this.drugMsg.useAuantity || this.drugMsg.mindoseUnit,
              useDays: '',
              amount: '',
              attention: '',
              useDrugTime: '',
              isDrugInducer: '0',
              drugFlag: new Date().getTime()
            }
          } else if (['3'].includes(this.drugMsg.drugType) || ['4'].includes(this.prescripType)) {
            this.form = {
              hospitalID: '',
              visitID: '',
              drugID: '',
              refDrugID: '',
              drugName: '',
              drugSpec: '',
              drugPrice: this.drugMsg.drugPrice,
              drugUsage: '',
              frequence: this.drugMsg.frequence || this.drugMsg.defaultFrequence,
              mindoseUnit: '',
              useAuantity: this.drugMsg.useAuantity,
              useDays: this.drugMsg.useDays,
              amount: this.drugMsg.amount,
              attention: this.drugMsg.attention,
              useDrugTime: this.drugMsg.useDrugTime,
              isDrugInducer: this.drugMsg.isDrugInducer,
              drugFlag: new Date().getTime()
            }
          }
        }

        updateFormData()
      } else {
        // this.close()
      }
    }
    // 'drugMsg.drugFlag': {
    //   handler() {
    //     const drugUsage = getKeyValue('drug_usage_his')[0].code
    //     const frequence = getKeyValue('frequence_his')[0].code

    //     const val = this.drugMsg
    //     if (val.drugType === '3' || this.prescripType === '4') {
    //       this.isMeng = true
    //     }

    //     // 根据需求调整 2023/10/26 17:00
    //     // 判断药品数据中的用法是否有效，如果有效则使用药品数据中的用法，否则使用默认用法
    //     this.form.drugUsage = getKeyValueText('drug_usage_his', val.drugUsage)
    //       ? val.drugUsage
    //       : drugUsage
    //     if (
    //       ['1', '2', '8'].includes(val.drugType) ||
    //       ['1', '2', '8'].includes(this.prescripType)
    //     ) {
    //       this.form.useDays = this.drugMsg.useDays
    //       this.form.amount = this.drugMsg.amount
    //       // 只有中成药、西药、以及呼市蒙药 需要回显单次剂量 其他类型不需要
    //       this.form.useAuantity = val.useAuantity || val.mindoseUnit
    //     }

    //     this.form.drugID = val.drugID
    //     // 原来的逻辑是如果有默认频次就用默认频次，没有就用频次，
    //     // 现在改成如果有默认频次就用默认频次，没有就用频次，都没有就用默认频次
    //     // this.form.frequence = val.defaultFrequence || val.frequence || frequence
    //     // 2021/10/26 17:00
    //     // 判断药品数据中的用药次数是否有效，如果有效则使用药品数据中的用药次数，否则使用默认用药次数
    //     this.form.frequence = getKeyValueText(
    //       'frequence_his',
    //       val.defaultFrequence
    //     )
    //       ? val.defaultFrequence
    //       : frequence

    //     this.form.drugName = val.commonName || val.drugName
    //     this.form.drugPrice = val.price || val.drugPrice
    //     this.form.drugSpec = val.drugSpec
    //     this.form.hospitalID = val.hospitalID
    //     this.form.refDrugID = val.id
    //     this.form.permitNO = val.permitNO
    //     this.form.drugFlag = val.drugFlag
    //     this.form.mindoseUnit = val.mindoseUnit
    //   },
    //   immediate: true
    // }
  },
  computed: {
    ...mapState(['hospitalInfo']),
    ...mapState('user', ['userInfos']),
    hospitalID() {
      return this.userInfos.hospitalID
    },
    limitText() {
      return `${this.drugMsg.commonName}：\n${this.drugMsg.phaSpecialLimitContent}\n该受者是否符合该药品的用药限制？`
    }
  },
  mounted() {
    this.$bus.on('isMengPre', val => {
      this.isMeng = val ? val : false
    })
    this.$bus.on('prescripClass', val => {
      this.prescripClass = val
    })
    this.$bus.on('doesNumber', val => {
      this.doesNumber = val
    })
    // 获取用药天数配置
    this.fetchDrugDaysConfig()
  },
  unmounted() {
    this.$bus.off('drugItem')
    this.$bus.off('cancelAddDrug')
  }
}
</script>

<style lang="scss" scoped>
.uni-textarea {
  display: flex;
  flex-direction: column;
  border-bottom: 0.021333rem solid #ececec;
  width: 14.634667rem;
  margin-left: 0.682667rem;
  // padding: .533333rem;
  .input_title {
    min-width: 2.986667rem;
    font-size: 0.597333rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888;
    line-height: 0.853333rem;
    // margin-bottom: .298667rem;
  }
  .input_row {
    width: 2.133333rem;
  }
  // .unit {
  // margin-top: .085333rem;
  // }
  .row_wrap {
    display: flex !important;
  }
}
.tip {
  padding: 0.768rem 0;
}
.drug_wrap {
  height: 19.2rem;
  .input_wrap {
    display: flex;
    padding: 0.682667rem 0 0.682667rem 0;
    align-items: center;
    justify-content: space-between;
    height: 0.810667rem;
    .input_row {
      display: flex;
      width: 3.626667rem;
      height: 100%;
      align-items: center;

      .input_con {
        text-align: right;
        // width: 2.816rem;
        // height: .938667rem;
      }
      .unit {
        margin-left: 0.213333rem;
        font-family: PingFang-SC-Medium, PingFang SC, Menksoft Budun !important;
      }
    }
  }
  .useAuantity {
    border-top: 0.021333rem solid #ececec;
  }
  .use_style {
    padding: 0.682667rem;
  }
  .drug_msg {
    display: flex;
    flex-direction: column;
    height: auto;
    padding: 0.682667rem 0.64rem 0.341333rem 0.64rem;
    justify-content: center;
    text:first-child,
    text:nth-child(2) {
      margin-bottom: 0.256rem;
    }
    .drug_name {
      font-size: 0.64rem;
      font-weight: 400;
      color: #222222;
      line-height: 0.853333rem;
    }
    .specification,
    .manufacturer {
      font-size: 0.512rem;
      font-weight: 400;
      color: #888888;
      line-height: 0.704rem;
    }
    .price {
      font-size: 0.64rem;
      font-weight: 400;
      color: #ff7555;
      line-height: 0.704rem;
    }
    .row_wrap {
      display: flex;
      justify-content: space-between;
      .add {
        width: 2.133333rem;
        height: 0.981333rem;
        background: #0089ff;
        border-radius: 0.085333rem;
        text-align: center;
        line-height: 0.981333rem;
        color: #fff;
        font-size: 0.597333rem;
        font-weight: 400;
      }

      .check-leaflet {
        width: 3.072rem;
        height: 1.024rem;
        border-radius: 0.085333rem;
        border: 0.021333rem solid #0089ff;
        font-size: 0.512rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #0089ff;
        line-height: 1.024rem;
        text-align: center;
        transform: translateY(-0.32rem);
      }
      .stockQuantity {
        font-size: 0.512rem;
        font-weight: 400;
        color: #fea602;
      }
    }
  }
}
.footer-box {
  width: 14.634667rem;
  height: 1.877333rem;
  display: flex;
  justify-content: space-between;
  .btn {
    min-width: 30%;
    text-align: center;
    background: #0089ff;
    border-radius: 0.938667rem;
    height: 1.877333rem;
    padding: 0 0.853333rem;
    line-height: 1.877333rem;
    font-size: 0.682667rem;
    color: #fff;
  }
}
.popup-wrap {
  width: 10.666667rem;
  min-height: 5.546667rem;
  border-radius: 0.341333rem;
  padding: 0.64rem 0.64rem 2.773333rem 0.64rem;

  background-color: #fff;
  font-size: 0.512rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #444444;
  line-height: 0.810667rem;
  overflow: hidden;
  position: relative;

  .title-wrap {
    width: 100%;
    height: 1.92rem;
    text-align: center;
    line-height: 1.92rem;
    font-size: 0.768rem;
    color: #222222;
    font-weight: 600;
  }

  .umbra {
    position: absolute;
    bottom: 3.84rem;
    left: 0rem;
    width: 100%;
    height: 0.426667rem;
    background-color: rgba(255, 255, 255, 0.5);
    background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
  }

  .content-wrap {
    height: auto;
    color: #222222;
    font-size: 0.64rem;
    margin-top: 0.426667rem;
    text-align: center;
    overflow-y: scroll;
    max-height: 17.066667rem;
    .theSon {
      word-wrap: break-word;
    }
  }
  .have-know {
    width: 6.4rem;
    height: 1.706667rem;
    text-align: center;
    line-height: 1.706667rem;
    color: #0089ff;
    border-radius: 0.853333rem;
    border: 0.021333rem solid #0089ff;
    position: absolute;
    left: 2.56rem;
    bottom: 0.768rem;
  }
  .protocol {
    width: 100%;
    height: 1.450667rem;
    display: flex;
    align-items: center;
    .protocol-text {
      font-size: 0.512rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #888;
    }
  }
}
</style>
